import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';
import AppModel from '../DataModel/AppModel';
import PageLoading from '../components/PageLoading';
import RaisedButton from 'material-ui/RaisedButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Close from 'material-ui/svg-icons/navigation/close';
import * as ReportGraph from '../components/ReportGraph';

const close_button_style= {
      position:'fixed',
      right:0,
      top:0,
      margin:'16px',
};


export default
@observer class GraphPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  componentDidMount() {
    // Call out to the d3 solution
    // console.log("componentDidMount");
    var graph_element = document.getElementById("graphdiv");
    if(graph_element) ReportGraph.drawReportGraph(graph_element);
  }

  componentDidUpdate() {
    // Call out to the d3 solution
    // console.log("componentDidUpdate");
    var graph_element = document.getElementById("graphdiv");
    if(graph_element) ReportGraph.drawReportGraph(graph_element);
  }

  close_graph() {
    this.context.router.goBack();
  }

  render() {
    var job = AppModel.currentJob;
    // Since the rendering of data happens outside this method,
    // we need to compute a result from the changing data, to
    // trigger a component update when data has changed.
    // This next line will make render depend on the data in lastMeasureReadTime
    // which will force an update whenever that changes.
    var last_update = job==null ? null : job.lastMeasureReadTime;
    var graphStyle={
      top:0,
      left:0,
      width:AppModel.uiSession.deviceWidth,
      height:AppModel.uiSession.deviceHeight,
      border:'0px',
      margin:'0px',
      padding:'0px',
      position:'fixed'
    }
    return (
      <PageLoading loading={AppModel.fetchingJobDetails}>
        <div style={graphStyle}>
          <div id="graphdiv"></div>
        </div>
        <FloatingActionButton style={close_button_style}
                              mini={true}
                              children={<Close />}
                              onTouchTap={this.close_graph.bind(this)} />
      </PageLoading>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/pages/GraphPage.jsx
 **/